import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { getWindowOrThrow } from "../../globals/getWindow";
import { singletonGetter } from "../../singletons/getter";
export var ActionStartTimeStore = function ActionStartTimeStore() {
    "use strict";
    var _this = this;
    _class_call_check(this, ActionStartTimeStore);
    this.actionStartTimeMap = new Map();
    this.recordActionStartTime = function(actionName) {
        var performance = getWindowOrThrow().performance;
        var startTime = performance.now();
        _this.actionStartTimeMap.set(actionName, startTime);
        return startTime;
    };
    this.getActionStartTime = function(actionName) {
        return _this.actionStartTimeMap.get(actionName);
    };
    this.cleanActionStartTime = function(actionName) {
        _this.actionStartTimeMap.delete(actionName);
    };
};
ActionStartTimeStore.get = singletonGetter(ActionStartTimeStore);
